import { QueryEntity } from '@datorama/akita';
import { InAppNotificationsState } from './in-app-notifications.store';

export class InAppNotificationsQuery extends QueryEntity<InAppNotificationsState> {
}
